import React, { useContext } from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import '../styles/css/Intro.css';
import { LanguageContext } from '../App';

const Intro = () => {
  const { language, translations } = useContext(LanguageContext);

  return (
    <Box className="intro-section" sx={{ py: { xs: 4, md: 8 }, bgcolor: 'background.default' }}>
      <Container maxWidth="lg">
        <Paper 
          elevation={2} 
          sx={{ 
            p: { xs: 3, md: 6 }, 
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)'
          }}
        >
          <Typography 
            variant="h2" 
            component="h2" 
            sx={{ 
              textAlign: 'center', 
              mb: 4,
              color: 'primary.main',
              fontSize: { xs: '2rem', md: '2.5rem' }
            }}
          >            
             {translations[language].introTitle}          
          </Typography>
          
          <Box sx={{ maxWidth: '800px', mx: 'auto' }}>
            <Typography 
              variant="h5" 
              component="p" 
              sx={{ 
                textAlign: 'center', 
                mb: 3,
                fontWeight: 300,
                lineHeight: 1.6,
                color: 'text.primary',
                fontSize: { xs: '1.1rem', md: '1.3rem' }
              }}
            >                
                {translations[language].introSubtitle}
            </Typography>
            
            <Typography 
              variant="body1" 
              sx={{ 
                textAlign: 'center', 
                mb: 2,
                lineHeight: 1.8,
                color: 'text.secondary',
                fontSize: { xs: '1rem', md: '1.1rem' }
              }}
            >                
                {translations[language].introBody1}
            </Typography>
            
            <Typography 
              variant="body1" 
              sx={{ 
                textAlign: 'center',
                lineHeight: 1.8,
                color: 'text.secondary',
                fontSize: { xs: '1rem', md: '1.1rem' }
              }}
            >
              
            </Typography>
          </Box>
          {/* Add video section below intro text */}
          <Box sx={{ mt: 4, textAlign: 'center' }}>
            <Typography
              variant="subtitle1"
              sx={{
                mb: 1,
                color: 'primary.main',
                fontWeight: 500,
                fontSize: { xs: '1rem', md: '1.1rem' }
              }}
            >
              {translations[language].introVideoPlay}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <video
                width="100%"
                style={{
                  maxWidth: 480,
                  borderRadius: 12,
                  boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
                  cursor: 'pointer'
                }}
                controls
                poster="/video.png"
              >
                <source src="https://studiorami.click/intro.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default Intro;
